import { getState } from '~src/state';
import { exportIMG } from '~core';

export const canvasJsonToImage = (json) => {
  return new Promise((resolve) => {
    const previewCanvas = getState('previewCanvas');

    previewCanvas.loadFromJSON(json, async () => {
      const preview = exportIMG(
        0.92,
        300,
        'base64',
        'jpeg',
        true,
        1,
        previewCanvas
      );

      previewCanvas.clear();
      resolve(preview);
    });
  });
};

window.canvasJsonToImage = canvasJsonToImage;
